"use client"

import { useEffect } from "react"
import { useTranslations, useLocale } from 'next-intl'
import { useSharedData } from "@/app/store/useDestinationSharedData"
import DestinationCard from "@/components/destination-card"
import HeaderPage from "@/components/header-page"

export default function DestinationsClient() {
  const t = useTranslations()
  const locale = useLocale()
  const { destinations, loadingDestination, errorDestinations, fetchDestinations } = useSharedData()

  useEffect(() => {
    fetchDestinations()
  }, [])

  return (
    <div dir={locale === 'ar' ? 'rtl' : 'ltr'}>
      <HeaderPage
        title={t('navigation.destinations')}
        breadcrumbs={[
          { label: t('common.home'), href: "/" },
          { label: t('navigation.destinations') }
        ]}
      />

      <div className="p-4">
        {errorDestinations && <p>{t('common.error')}</p>}

        {loadingDestination ? (
          <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-6">
            {[...Array(10)].map((_, i) => (
              <div key={i} className="flex flex-col bg-gray-300 shadow rounded-3xl overflow-hidden animate-pulse">
                <div className="h-64 w-full bg-gray-300"></div>
                <div className="p-4 flex justify-start items-start">
                  <div className={locale === 'ar' ? 'rotate-90' : '-rotate-90'}>
                    <div className="h-4 w-20 bg-gray-300 rounded"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-6">
            {destinations.map((destination: any) => (
              <DestinationCard
                key={destination.id}
                item={destination}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
